const INITIAL_STATE = { orders: [], ordersApi: [] };

const setOrdersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_ALL_ORDERS":
      return { ...state, orders: [...action.payload] };
    case "GET_ALL_ORDERS":
      if (state.orderStatus === action.orderStatus) {
        // Same filter — append for infinite scroll
        return {
          ...state,
          orders: [...state.orders, ...action.payload.orders],
          lastVisible: action.payload.lastVisible,
          hasMore: action.payload.hasMore,
        };
      } else {
        // New filter — reset orders
        return {
          ...state,
          orders: [...action.payload.orders],
          lastVisible: action.payload.lastVisible,
          hasMore: action.payload.hasMore,
          orderStatus: action.orderStatus,
        };
      }
    case "GET_SINGLE_ORDER":
      return {
        ...state,
        orders: [action.payload, ...state.orders],
      };

    case "UPDATE_ORDER":
      return {
        ...state,
        orders: state.orders.map((order) => {
          if (order.id == action.payload.id) {
            return action.payload;
          } else {
            return order;
          }
        }),
      };
    default:
      return { ...state };
  }
};
export default setOrdersReducer;
